import { Box, Grid, Stack } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { constants } from '../../constants';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMButton } from '../../ui-elements/MyMButton';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';

/** MyMine Version2.0 SpecializedPartsServiceLv2SubLv1画面新規追加
* SpecializedPartsServiceLv2SubLv1 Page Content
*/
export const SpecializedPartsServiceLv2SubLv1 = () => {

  // 画面幅が400px以上899px以下かどうかを判定
  const isMediumScreen = useMediaQuery('(min-width: 400px) and (max-width: 899px)');

  const mediumScreenImageSize = {
    width: '345px',
    height: '210px',
    margin: '0 auto',  
    display: 'block'   
  };

  const ImageLinkPanel = (props) => {
    const { index, headerText, linkText, url, imgPath } = props
    return (
      <Grid item xs={11} key={index}>
        <Grid container spacing={5} justifyContent="space-between" alignItems="center">
          <Grid item xs={12} md={5} sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}>
            <MyMLabel sx={{  marginBottom: '8px' }}>{headerText}</MyMLabel>
            <Box sx={{ paddingLeft: '1ch' }}>
            <MyMButton sx={{ mt: 1, width: '80%' }} onClick={() => window.open(url, '_blank')} >{linkText}</MyMButton>
            </Box>
          </Grid>
          <Grid item xs={12} md={5} sx={{ mb: 1, display: 'flex', justifyContent: 'center' }}> {/* 中央揃えのための修正 */}
            <MyMImage
              screenId={screenId}
              filePath={imgPath}
              alt='BradkenCompanyOverview'
              height={isMediumScreen ? mediumScreenImageSize.height : '160px'}
              width={isMediumScreen ? mediumScreenImageSize.width : '95%'}
              style={isMediumScreen ? { ...mediumScreenImageSize, objectFit: 'cover' } : { objectFit: 'cover' }}
            />
          </Grid>
        </Grid>
      </Grid>
    )
  }

  const ImagePanel = (props) => {
    const { index, captionText, imgPath } = props

    return (
      <Grid item xs={12} lg={6} key={index}>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}> {/* 中央揃えのための追加 */}
          <MyMImage
            screenId={screenId}
            filePath={imgPath}
            alt='BradkenCompanyOverview'
            height={isMediumScreen ? mediumScreenImageSize.height : '230px'}
            width={isMediumScreen ? mediumScreenImageSize.width : '100%'}
            style={isMediumScreen ? { ...mediumScreenImageSize, objectFit: 'cover' } : { objectFit: 'cover' }}
          />
        </Box>
        <MyMLabel sx={{ marginTop: '5px', textAlign: 'center' }}>{captionText}</MyMLabel>
      </Grid>
    )
  }


  const screenId = 'MyM307';
  const scrollmRef = useRef(null)

  const { controlSettings } = useWebContext(screenId);

  const apiRequest = useMyMApi(screenId);
  const [isInitLoading, setIsInitLoading] = useState(true);
  const isPc = useMediaQuery(mediaQuery.pc);

  useEffect(() => {
    const endLoading = () => setIsInitLoading(false);

    apiRequest.requestJson('api/specialized-parts-service/lv2-1', 'GET', endLoading, endLoading);
  }, [])

  if (isInitLoading)
    return <MyMProgress />

  const SectionLabel = (props) => <MyMVariantLabel variant='h4' className='fs-3 fw-bolder'>{props.children}</MyMVariantLabel>

  return (
    <Box className='py-1'>
      <Box>
        <MyMVariantLabel variant='h5'>{controlSettings.LabelList.lblBradken}</MyMVariantLabel>
      </Box>
      {isPc ? (
        <Grid container>
          <Grid item xs={3} />
          <Grid item xs={6} >
            <Box sx={{ marginTop: 1 }} ref={scrollmRef}>
              <SectionLabel>{controlSettings.LabelList.lblProductsAndSolutions}</SectionLabel>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                background: constants.CorporateColor.Bradken,
                color: 'white',
                paddingLeft: '5px',
                marginTop: '15px'
              }}>
                <MyMLabel fontSize='25px'>{controlSettings.LabelList.lblMobileMiningEquipment}</MyMLabel>
              </Box>
              <Box sx={{ marginTop: '15px' }}>
                <MyMLabel>{controlSettings.LabelList.lblMobileMiningEquipmentDetail}</MyMLabel>
              </Box>
              <Box sx={{  marginTop: '15px' }}>
                <Grid sx={{ paddingLeft: 0 }} >
                  {[...Array(6)].map((_, i) => {
                    const headerText = controlSettings.LabelList['lblMobileMiningEquipmentHeader' + (1 + i)];
                    const linkText = controlSettings.LabelList['lnkMobileMiningEquipmentSeeMoreDetails' + (1 + i)];
                    const url = controlSettings.UrlList['urlMobileMiningEquipmentSeeMoreDetails' + (1 + i)];
                    const imgPath = controlSettings.ImageList['imgMobileMiningEquipment' + (1 + i)];

                    if (!headerText || !linkText || !url || !imgPath) {
                      return null;
                    }

                    return (
                      <Grid item xs={12} key={i}>
                        <ImageLinkPanel
                          headerText={headerText}
                          linkText={linkText}
                          url={url}
                          imgPath={imgPath}
                        />
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
              <Box sx={{ mt: 1 }}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  height: '100%',
                  background: constants.CorporateColor.Bradken,
                  color: 'white',
                  paddingLeft: '5px',
                  marginTop: '15px'
                }}>
                  <MyMLabel fontSize='25px'>{controlSettings.LabelList.lblMineralProcessing}</MyMLabel>
                </Box>
                <MyMLabel>{controlSettings.LabelList.lblMineralProcessingDetail}</MyMLabel>
              </Box>
              <Box sx={{ marginLeft: '1px', marginTop: '15px' }}>
                <Grid container sx={{ paddingLeft: 0 }} columnSpacing={6} rowSpacing={2}>
                  {[...Array(6)].map((_, i) => {
                    const headerText = controlSettings.LabelList['lblMineralProcessingHeader' + (1 + i)];
                    const linkText = controlSettings.LabelList['lnkMineralProcessingSeeMoreDetails' + (1 + i)];
                    const url = controlSettings.UrlList['urlMineralProcessingSeeMoreDetails' + (1 + i)];
                    const imgPath = controlSettings.ImageList['imgMineralProcessing' + (1 + i)];

                    if (!headerText || !linkText || !url || !imgPath) {
                      return null;
                    }

                    return (
                      <ImageLinkPanel
                        key={i}
                        headerText={headerText}
                        linkText={linkText}
                        url={url}
                        imgPath={imgPath}
                      />
                    );
                  })}
                </Grid>
              </Box>
              <Grid item xs={12} lg={12}>
                <Box>
                  <Box sx={{
                    display: 'flex',
                    width: '100%',
                    background: constants.CorporateColor.Bradken,
                    color: 'white',
                    paddingLeft: '5px',
                    marginTop: '15px'
                  }}>
                    <MyMLabel fontSize='25px'>{controlSettings.LabelList.lblOtherSolutions}</MyMLabel>
                  </Box>
                  <Stack spacing={5} sx={{ mt: 1 }}>
                    <Box>
                      <MyMLabel sx={{ paddingLeft: '1px', marginBottom: '8px' }}>
                        {controlSettings.LabelList.lblTransportSolutions}
                      </MyMLabel>
                      <Box sx={{ display: 'flex', paddingLeft: '2ch' }}>
                     
                        <MyMButton
                          sx={{ mt: 1, width: '300px' }}
                          onClick={() => window.open(controlSettings.UrlList.urlTransportSolutionsSeeMoreDetails, '_blank')}
                        >
                          {controlSettings.LabelList.lnkTransportSolutionsSeeMoreDetails}
                        </MyMButton>
                      </Box>
                    </Box>
                    <Box>
                      <MyMLabel sx={{ paddingLeft: '1px', marginBottom: '8px' }}>{controlSettings.LabelList.lblWearPiping}</MyMLabel>

                      <Box sx={{ display: 'flex', paddingLeft: '2ch' }}>
                        <MyMButton
                          sx={{ mt: 1, width: '300px' }}
                          onClick={() => window.open(controlSettings.UrlList.urlWearPipingSeeMoreDetails, '_blank')}
                        >
                          {controlSettings.LabelList.lnkWearPipingSeeMoreDetails}
                        </MyMButton>
                      </Box>
                    </Box>
                  </Stack>
                </Box>
              </Grid>
              <Box sx={{ marginTop: 7 }}>
                <SectionLabel>{controlSettings.LabelList.lblHotTopic}</SectionLabel>
                <Grid container className='ps-3' sx={{ mt: 1 }} columnSpacing={4} rowSpacing={2}>
                  {[...Array(6)].map((_, i) => {
                    const caption = controlSettings.LabelList['lblHotTopicCaption' + (i + 1)];
                    const imgPath = controlSettings.ImageList['imgHotTopic' + (i + 1)];

                    if (!caption || !imgPath) {
                      return null;
                    }

                    return (
                      <ImagePanel
                        key={i}
                        index={i}
                        captionText={caption}
                        imgPath={imgPath}
                      />
                    );
                  })}
                </Grid>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={3} />
        </Grid>
      ) : (
        <Box sx={{ width: '100%', px: 2 }}>
          <Box sx={{ marginTop: 1 }} ref={scrollmRef}>
            <SectionLabel>{controlSettings.LabelList.lblProductsAndSolutions}</SectionLabel>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              height: '100%',
              background: constants.CorporateColor.Bradken,
              color: 'white',
              paddingLeft: '5px',
              marginTop: '15px'
            }}>
              <MyMLabel fontSize='25px'>{controlSettings.LabelList.lblMobileMiningEquipment}</MyMLabel>
            </Box>
            <Box sx={{ marginTop: '15px' }}>
              <MyMLabel>{controlSettings.LabelList.lblMobileMiningEquipmentDetail}</MyMLabel>
            </Box>
            <Box sx={{ marginTop: '15px' }}>
              <Grid>
                {[...Array(6)].map((_, i) => {
                  const headerText = controlSettings.LabelList['lblMobileMiningEquipmentHeader' + (1 + i)];
                  const linkText = controlSettings.LabelList['lnkMobileMiningEquipmentSeeMoreDetails' + (1 + i)];
                  const url = controlSettings.UrlList['urlMobileMiningEquipmentSeeMoreDetails' + (1 + i)];
                  const imgPath = controlSettings.ImageList['imgMobileMiningEquipment' + (1 + i)];

                  if (!headerText || !linkText || !url || !imgPath) {
                    return null;
                  }

                  return (
                    <Grid item xs={12} key={i}>
                      <ImageLinkPanel
                        headerText={headerText}
                        linkText={linkText}
                        url={url}
                        imgPath={imgPath}
                      />
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
            <Box sx={{ mt: 1 }}>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                background: constants.CorporateColor.Bradken,
                color: 'white',
                paddingLeft: '5px',
                marginTop: '15px'
              }}>
                <MyMLabel fontSize='25px'>{controlSettings.LabelList.lblMineralProcessing}</MyMLabel>
              </Box>
              <MyMLabel>{controlSettings.LabelList.lblMineralProcessingDetail}</MyMLabel>
            </Box>
            <Box sx={{ marginTop: '15px' }}>
              <Grid container columnSpacing={2} rowSpacing={2}>
                {[...Array(6)].map((_, i) => {
                  const headerText = controlSettings.LabelList['lblMineralProcessingHeader' + (1 + i)];
                  const linkText = controlSettings.LabelList['lnkMineralProcessingSeeMoreDetails' + (1 + i)];
                  const url = controlSettings.UrlList['urlMineralProcessingSeeMoreDetails' + (1 + i)];
                  const imgPath = controlSettings.ImageList['imgMineralProcessing' + (1 + i)];

                  if (!headerText || !linkText || !url || !imgPath) {
                    return null;
                  }

                  return (
                    <ImageLinkPanel
                      key={i}
                      headerText={headerText}
                      linkText={linkText}
                      url={url}
                      imgPath={imgPath}
                    />
                  );
                })}
              </Grid>
            </Box>
            <Box>
              <Box sx={{
                display: 'flex',
                width: '100%',
                background: constants.CorporateColor.Bradken,
                color: 'white',
                paddingLeft: '5px',
                marginTop: '15px'
              }}>
                <MyMLabel fontSize='25px'>{controlSettings.LabelList.lblOtherSolutions}</MyMLabel>
              </Box>
              <Stack spacing={3} sx={{ mt: 1 }}>
                <Box>
                  <MyMLabel sx={{ paddingLeft: '1px', marginBottom: '8px' }}>
                    {controlSettings.LabelList.lblTransportSolutions}
                  </MyMLabel>
                  <Box sx={{ display: 'flex' }}>
                    <MyMButton
                      sx={{ mt: 1, width: '100%' }}
                      onClick={() => window.open(controlSettings.UrlList.urlTransportSolutionsSeeMoreDetails, '_blank')}
                    >
                      {controlSettings.LabelList.lnkTransportSolutionsSeeMoreDetails}
                    </MyMButton>
                  </Box>
                </Box>
                <Box>
                  <MyMLabel sx={{ paddingLeft: '1px', marginBottom: '8px' }}>{controlSettings.LabelList.lblWearPiping}</MyMLabel>

                  <Box sx={{ display: 'flex' }}>
                    <MyMButton
                      sx={{ mt: 1, width: '100%' }}
                      onClick={() => window.open(controlSettings.UrlList.urlWearPipingSeeMoreDetails, '_blank')}
                    >
                      {controlSettings.LabelList.lnkWearPipingSeeMoreDetails}
                    </MyMButton>
                  </Box>
                </Box>
              </Stack>
            </Box>
            <Box sx={{ marginTop: 5 }}>
              <SectionLabel>{controlSettings.LabelList.lblHotTopic}</SectionLabel>
              <Grid container sx={{ mt: 1 }} columnSpacing={2} rowSpacing={2}>
                {[...Array(6)].map((_, i) => {
                  const caption = controlSettings.LabelList['lblHotTopicCaption' + (i + 1)];
                  const imgPath = controlSettings.ImageList['imgHotTopic' + (i + 1)];

                  if (!caption || !imgPath) {
                    return null;
                  }

                  return (
                    <ImagePanel
                      key={i}
                      index={i}
                      captionText={caption}
                      imgPath={imgPath}
                    />
                  );
                })}
              </Grid>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}

export default SpecializedPartsServiceLv2SubLv1;

